import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Menu } from '../menu.model';
import { MenuService } from '../menu.service';

@Component({
  selector: 'app-menulist',
  templateUrl: './menulist.component.html',
  styleUrls: ['./menulist.component.css'],
  queries: {
    contentRef: new ViewChild("Modal")
  },
})
export class MenulistComponent implements OnInit {

  menus: Menu[] = [];
  displayedColumns: string[] = ['id', 'name', "edit", "delete"];
  dataSource!: MatTableDataSource<Menu>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  spinnerOverlay = false
  public contentRef!: TemplateRef<any>;
  menu: Menu = {} as Menu;
  Advstatus: { id: number, name: string }[] = [];
  selectedStatus:number = 1

  constructor(private service: MenuService,
    private router: Router,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private translate:TranslateService) { }

  ngOnInit() {
    this.get();
  }

  get() {
    this.spinnerOverlay = true;
    this.service.getAll().subscribe(data => {
      this.menus = data.sort((n1, n2) => n2.id - n1.id);
      this.dataSource = new MatTableDataSource(this.menus);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  createNew() {
    this.router.navigate(['./master/systemsettings/addmenu']);
  }

  edit(id:number) {
    this.router.navigate(['./master/systemsettings/editmenu/' + id]);
  }

  onDelete(id:number) {
    this.menu.id = id;
    this.openDialog();
  }

  delete() {
    this.spinnerOverlay = true;
    this.dialog.closeAll();
    this.service.Delete(this.menu.id).subscribe(data => {
      this.openSnackBar(this.translate.instant("deletedSuccessfully"),'snackBarSuccess');
      this.spinnerOverlay = false;
      this.get();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        this.dialog.closeAll();
        if (error.error.message) {
          this.openSnackBar(error.error.message, "snackBarError");
        }
        else {
          this.openSnackBar("Internal server error", "snackBarError");
        }
      })
  }

  confirmDelete() {
    this.delete();
  }

  openSnackBar(message:string, cssclass:string) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '300px',
    });
  }

  onNoClick(): void {
    this.dialog.closeAll();
  }

  selectChange(){
    this.get();
  }

}
